import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Page from '../Fuse/Page';
import Administrators from '../Administrators/Administrators';
import LocalAccountsStore from '../../stores/LocalAccounts/LocalAccountsStore';
import ConsoleStore from '../../stores/ConsoleStore';
import { ROLE_READ_ONLY } from '../../stores/Administrators/AdministratorModalStore';
import './LocalAccounts.css';

class LocalAccounts extends Component {
    static propTypes = {
        localAccounts: LocalAccountsStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
    };

    render() {
        return <Page title="Administrators - Local Accounts">
            <Administrators
                modalSubtitle="Local Account"
                store={this.props.localAccounts.admins}
                currentUserId={this.props.console.userId}
                readOnly={this.props.console.authority === ROLE_READ_ONLY.value}
                sendInvitationOption
            />
        </Page>;
    }
}

export default inject('localAccounts', 'console')(observer(LocalAccounts));
